var SENTRY_RELEASE;SENTRY_RELEASE={name: "Insights", version: "1.0.47"};